import Constants from "../utils/constants";
import { API } from "../apis/APIsConfig";

export const ICONS = {
  5: "old",
  7: "user",
  8: "disability",
  9: "cash",
  11: "hospital",
  13: "aportes",
};

export function getBeneficios() {
  return API.get(Constants.APIURLS.BENEFICIOS);
}

export function getRequisitos(codBeneficio) {
  return API.get(Constants.APIURLS.GETREQUISITOS + codBeneficio);
}

export function validateRequest(codBeneficio) {
  return API.get(Constants.APIURLS.VALIDATESOLICITUD + codBeneficio);
}

export function getBPMSExternalLogin(cedula: String, nombre: String, email: String) {
  return API.post(Constants.APIURLS.BPMS.EXTERNALLOGIN, {
    cedula: cedula.replace(/\D/g,""), nombre: nombre, email: email
  });
}

export function getBPMSExternalLoginPuntual(code: String, cedula: String) {
  return API.post(Constants.APIURLS.BPMS.EXTERNALLOGINPUNTUAL, {
    code: code, cedula: cedula.replace(/\D/g,"")
  });
}

export function saveBeneficio(codBeneficio: number, documents: any[]) {
  return API.post(Constants.APIURLS.SAVEBENEFICIO, {
    codBeneficio: codBeneficio,
    documentos: documents,
  });
}
